module.exports = __webpack_public_path__ + "img/fsi-bg.c977624a.png";